'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./checkbox.scss');

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _logger = require('../../utils/logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var logger = new _logger2.default();

function Checkbox(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      reverse = _ref.reverse,
      size = _ref.size,
      align = _ref.align,
      style = _ref.style,
      checkIcon = _ref.checkIcon,
      indeterminate = _ref.indeterminate,
      invertColors = _ref.invertColors,
      props = _objectWithoutProperties(_ref, ['children', 'className', 'disabled', 'reverse', 'size', 'align', 'style', 'checkIcon', 'indeterminate', 'invertColors']);

  var classes = (0, _classnames2.default)('checkbox', className, disabled && 'checkbox--disabled', align && 'checkbox--align-' + align, 'checkbox--' + size);

  var checkboxIcon = indeterminate ? 'check-square' : checkIcon;
  logger.log('"checkIcon" will be deprecated, please use "icon" instead');

  return _react2.default.createElement(
    'label',
    { className: classes, style: style },
    _react2.default.createElement('input', _extends({
      ref: function ref(elem) {
        if (elem) {
          elem.indeterminate = indeterminate; // eslint-disable-line
        }
      },
      type: 'checkbox',
      className: 'checkbox__input',
      disabled: disabled
    }, props)),
    reverse && children && _react2.default.createElement(
      'span',
      { className: 'checkbox__label' },
      children
    ),
    _react2.default.createElement(_icon2.default, { name: checkboxIcon, className: 'checkbox__icon' }),
    !reverse && children && _react2.default.createElement(
      'span',
      { className: 'checkbox__label' },
      children
    )
  );
}

Checkbox.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  indeterminate: _propTypes2.default.bool,
  reverse: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'x-large']),
  style: _propTypes2.default.object,
  align: _propTypes2.default.oneOf(['flex-start', 'center', 'flex-end', 'baseline', 'stretch']),
  checkIcon: _propTypes2.default.string,
  invertColors: _propTypes2.default.bool
};

Checkbox.defaultProps = {
  size: 'medium',
  checkIcon: 'check',
  indeterminate: false,
  invertColors: false
};

exports.default = Checkbox;